















import { Component, Prop, Vue } from 'vue-property-decorator'
import LangPicker from '@/components/LangPicker.vue'

@Component({
  components: {
    LangPicker
  }
})
export default class MenuBar extends Vue {
  get menuOptions () {
    return [
      {
        label: this.$t('menu.intro'),
        link: '#intro'
      },
      {
        label: this.$t('menu.projects'),
        link: '#projects'
      },
      {
        label: this.$t('menu.education'),
        link: '#education'
      },
      {
        label: this.$t('menu.skills'),
        link: '#skills'
      },
      {
        label: this.$t('menu.contacts'),
        link: '#contacts'
      // },
      // {
      //   label: this.$t('menu.portfolio'),
      //   link: '/portfolio'
      }
    ]
  }
}
